<template>
  <div>
    <div id="principal" class="w3-col w3-white w3-margin-top w3-padding">
      <span class="w3-button">{{titulo}}</span>

      <button
        class="w3-button w3-green w3-left"
        @click="mostrarModalInserirTelefone()">
        <i class="fas fa-plus"></i>
      </button>

      <div class="w3-col w3-margin-top">
        <p class="texto-cinza w3-center" v-show="telefones.length == 0">
          <span>Nenhum telefone cadastrado</span>
        </p>
      </div>

      <div class="w3-col" v-show="telefones.length > 0" v-cloak>
        <div
          :key="index" v-for="(telefone, index) in telefones"
          class="w3-col card-item w3-border w3-padding-small"
          style="cursor: pointer;">

          <div class="w3-col">
            <strong class="w3-text-theme">{{aplicarMascaraTelefone(telefone)}}</strong>

            <div class="w3-right">
              <span @click="alterarTelefone(index)">(<span class="link">alterar</span>)</span>
              <span>|</span>
              <span @click="excluirTelefone(index)">(<span class="link">excluir</span>)</span>
            </div>
          </div>

          <div class="w3-col">
            <strong>{{getDescricaoTipoTelefone(telefone.tipo_telefone)}}</strong>
            <span v-if="telefone.ramal"> (ramal {{telefone.ramal}})</span>
          </div>
          
          <span class="w3-col" v-if="telefone.observacao">{{telefone.observacao}}</span>
        </div>
      </div>
    </div>

    <div class="w3-modal" style="display: block" v-if="coleta_visivel">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <span
            @click="fechar()"
            class="w3-button w3-display-topright w3-text-theme w3-large">&times;</span>

          <h5 class="w3-left w3-col m12 titulo" v-cloak>
            <b class="texto-vermelho">
              <i class="fa fa-map fa-fw"></i>
              <span>{{titulo_tela_coleta}}</span>
            </b>
          </h5>
        </header>

        <div class="w3-row-padding">
          <div class="w3-col s12 m6">
            <label for="tipoTelefone">Tipo do telefone</label>
            <select
              id="tipoTelefone"
              ref="campoTipoTelefone"
              class="w3-select w3-border"
              v-model="tipo_telefone">
              
              <option
                :key="tipo_tel.sigla"
                v-for="tipo_tel in tipos_telefones"
                :value="tipo_tel.sigla">
                {{tipo_tel.descricao}}
              </option>
            </select>
          </div>

          <div class="w3-col s12 m6">
            <label>Telefone (somente números)</label>
            <input
              type="number"
              ref="campoTelefone"
              class="w3-input w3-border"
              maxlength="15"
              v-model="telefone">
          </div>

          <div class="w3-col s12 m6">
            <label>Ramal</label>
            <input
              type="number"
              ref="campoRamal"
              class="w3-input w3-border"
              maxlength="4"
              v-model="ramal">
          </div>

          <div class="w3-col s12 m6">
            <label>Observações</label>
            <input
              type="text"
              class="w3-input w3-border"
              maxlength="100"
              v-model="observacao">
          </div>
        </div>

        <footer class="w3-container conteudo-centralizado">
          <button
            class="w3-btn w3-theme"
            style="margin-top: 10px; margin-bottom: 10px;"
            @click="confirmarColetaTelefone()">
            <span>Confirmar</span>
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
  import toastr from 'toastr';
  import Biblioteca from '@/components/Repositorio/Biblioteca';

  export default {
    name: 'FrameTelefones',

    props: {
      titulo: {
        type: String,
        default: 'Telefones',
        required: false
      },

      telefonesCarregar: {
        type: Array,
        default: [],
        required: false
      }
    },

    data() {
      return {
        telefones: [],

        titulo_tela_coleta: 'Inserir Telefone',
        coleta_visivel: false,
        indice_edicao: -1,

        tipo_telefone: '',
        telefone: '',
        ramal: '',
        observacao: '',

        tipos_telefones: [
          {
            sigla: 'R',
            descricao: 'Residencial'
          },
          {
            sigla: 'C',
            descricao: 'Comercial'
          },
          {
            sigla: 'E',
            descricao: 'Celular'
          },
          {
            sigla: 'A',
            descricao: 'Recado'
          },
          {
            sigla: 'P',
            descricao: 'Telefone de Pai ou Mãe'
          },
          {
            sigla: 'G',
            descricao: '0800/0300'
          }
        ]
      }
    },

    methods: {
      mostrarModalInserirTelefone() {
        this.coleta_visivel = true;
        this.$nextTick(() =>this.$refs.campoTipoTelefone.focus());
      },

      confirmarColetaTelefone() {
        if (Biblioteca.stringVazia(this.tipo_telefone)) {
          Biblioteca.exclamar('Selecione o tipo do telefone!');
          this.$nextTick(() =>this.$refs.campoTipoTelefone.focus());
          return;
        }

        if (Biblioteca.stringVazia(this.telefone)) {
          Biblioteca.exclamar('Informe o telefone!');
          this.$nextTick(() =>this.$refs.campoTelefone.focus());
          return;
        }

        if (Biblioteca.numeros(this.telefone) != this.telefone) {
          Biblioteca.exclamar('Informe apenas números de um telefone válido!');
          this.$nextTick(() =>this.$refs.campoTelefone.focus());
          return;
        }

        if (!Biblioteca.em(this.telefone.length, [10, 11])) {
          Biblioteca.exclamar('Informe um telefone válido!');
          this.$nextTick(() =>this.$refs.campoTelefone.focus());
          return;
        }

        if (!Biblioteca.stringVazia(this.ramal)) {
          if (
            (Biblioteca.valorInt(this.ramal) < 0) ||
            (Biblioteca.valorInt(this.ramal) > 9999)
          ) {
            Biblioteca.exclamar('Informe um ramal válido!');
            this.$nextTick(() =>this.$refs.campoRamal.focus());
            return;
          }
        }

        for (let i = 0; i < this.telefones.length; i++) {
          if (i == this.indice_edicao) {
            continue;
          }

          if (this.telefone == Biblioteca.numeros(this.telefones[i].telefone)) {
            Biblioteca.exclamar('Telefone já cadastrado!');
            this.$nextTick(() =>this.$refs.campoTelefone.focus());
            return;
          }
        }

        if (this.indice_edicao == -1) {
          this.telefones.push({
            tipo_telefone: this.tipo_telefone,
            telefone: this.telefone,
            ramal: this.ramal,
            observacao: this.observacao
          })
        }
        else {
          this.telefones[this.indice_edicao].tipo_telefone = this.tipo_telefone;
          this.telefones[this.indice_edicao].telefone = this.telefone;
          this.telefones[this.indice_edicao].ramal = this.ramal;
          this.telefones[this.indice_edicao].observacao = this.observacao;
        }

        this.limparColetaDados();
        this.coleta_visivel = false;

        this.$emit('confirmar', this.telefones);
      },

      carregar(telefones_carregar) {
        this.telefones = JSON.parse(JSON.stringify(telefones_carregar));
      },

      limparColetaDados() {
        this.tipo_telefone = '';
        this.telefone = '';
        this.ramal = '';
        this.observacao = '';
        this.indice_edicao = -1;
      },

      fechar() {
        this.coleta_visivel = false;
      },

      getDescricaoTipoTelefone(sigla) {
        for (let i = 0; i < this.tipos_telefones.length; i++) {
          if (this.tipos_telefones[i].sigla == sigla) {
            return this.tipos_telefones[i].descricao;
          }
        }

        return 'Indefinido';
      },

      getTelefones() {
        for (let i = 0; i < this.telefones.length; i++) {
          this.telefones[i].ordem = 0;
        }

        return this.telefones;
      },

      alterarTelefone(index) {
        this.indice_edicao = index;
        this.tipo_telefone = this.telefones[index].tipo_telefone;
        this.telefone = Biblioteca.numeros(this.telefones[index].telefone);
        this.ramal = this.telefones[index].ramal;
        this.observacao = this.telefones[index].observacao;

        this.coleta_visivel = true;
        this.$nextTick(() =>this.$refs.campoTelefone.focus());
      },

      excluirTelefone(index) {
        this.telefones.splice(index, 1);
      },

      aplicarMascara(numeros, mascara) {
        return Biblioteca.aplicarMascara(numeros, mascara);
      },

      aplicarMascaraTelefone(telefone) {
        return Biblioteca.aplicarMascaraTelefone(
          telefone.telefone,
          telefone.tipo_telefone == 'G'
        )
      }
    },

    created() {
      if ((!this.telefonesCarregar) || (this.telefonesCarregar.length <= 0)) {
        return;
      }

      this.telefones = JSON.parse(JSON.stringify(this.telefonesCarregar));
    }
  }
</script>

<style scoped>
  #principal {
    border: 1px solid #aaaaaa;
    border-radius: 10px;
  }

  .link {
    color: #9c1d1c;
    text-decoration: underline;
  }

  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
  }

  .card-item:hover {
    border: 1px solid #bfbfbf; 
    box-shadow: #7a7a7a 1px 2px 5px 2px;
  }

</style>


// WEBPACK FOOTER //
// src/components/Frames/FrameTelefones.vue